module.exports = __webpack_public_path__ + "static/media/bay.14f51ac3.svg";